import axios from "axios";
import configData from "config.json";
import { UserData } from "components/Sidebar/Sidebar_Principal";
import { ResponseRequest, ResponseRequestGeneric } from "components/Types/GeneralTypes";
import { authHeader, authHeaderWithToken, authHeaderWithUserData } from "helpers/auth-header";
import { authenticationService } from "services/authentication.service";
import { DetalleModificacionHE, DetalleServidoresModificacionHE } from "./TypesModificacion";
import { hadleAxiosErrorResponse } from "helpers/handle-response";
import { DataActividadSave, DetalleActividadPlanHEDTO, DetalleRegimenLaboralHEDTO, DetalleServidoresPlanificacionHE, DetalleServidorPlanHEDTO } from "../PlanificacionHE/TypesPlanificacionHE";

const URL_INFORMACION_SERVIDOR_MOD_HE = `${configData.SERVER_URL}ModificacionPresupuestoHE/DetalleModServidorHE`;

export async function ObtenerinfoModificacionPHE(fechaDesde: string, fechaHasta: string, puedeRealizarAccion: boolean) {
    const url = configData.SERVER_URL + `ModificacionPresupuestoHE/informacionServidoresModPresup/${fechaDesde}/${fechaHasta}/${puedeRealizarAccion}`;

    const infoUsuario: UserData = authenticationService.currentUserValue;

    var informacionPlanificacion: DetalleModificacionHE = {
        puedeRealizarAccion: false,
        anio: 0,
        mes: 0,
        nombreMes: "",
        idSolicModPresupuesto: 0,
        estadoSolicitudMod: "",
        refSolicModPresupuesto: "",
        gruposActividad: [],
        listadoServidores: [],
        listadoServidoresOtrasUnidades: [],
        listadoRegimenLaborales: [],
        listadoRegimenLaboralesPlan: [],
        paramsHorasMesPlanificacionHE: [],
        novedadesServidores: [],
        detalleActividadPlanHEDTOs: [],
        informacionAprobador: {
            informacionAprobador: {
                nombres: '',
                apellidos: '',
                email: '',
                idpersona: 0,
                tipoAprobador: -1,
                TipoAprobadorString: '',
                idEstructuraOrganica: 0,
                idEstructuraOrganicaAprobacion: 0,
            },
            mensaje: ''
        },
        nombreUnidadAprobacion: ''
    }
    var infoResponse: ResponseRequest = { status: -1, dataResponse: informacionPlanificacion }
    try {

        const respuesta = await axios.get(url,
            {
                headers: authHeaderWithUserData(infoUsuario)
            }
        )
        informacionPlanificacion = respuesta.data;
        infoResponse = {
            status: respuesta.status,
            dataResponse: informacionPlanificacion,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            infoResponse = {
                status: error.response.status,
                dataResponse: informacionPlanificacion,
                errorMessage: error.response.data ?? ""
            }

        }
    }

    return infoResponse;

}

export async function ObtenerInformacionServidorModHE(fechaDesde: string, fechaHasta: string, identificacion: string) {
    var respuesta: ResponseRequestGeneric<DetalleServidoresModificacionHE> = {
        status: -1
    };

    try {

        const URL_COMPLETA = `${URL_INFORMACION_SERVIDOR_MOD_HE}/${fechaDesde}/${fechaHasta}/${identificacion}`
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })

        var data: DetalleServidoresModificacionHE = responseAxios.data;


        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }


    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleServidoresModificacionHE>(error)
    }

    return respuesta
}

export async function ObtenerVistaPreviaFormularioModificacionPHE(dataModPhe: any, isAumento: boolean, desdefecha: string, hastaFecha: string, valorNuevo: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;
    var respuestaResponse: ResponseRequest = { status: -1 }
    const URL = `${configData.SERVER_URL}ModificacionPresupuestoHE/SolicitudModPresupuestoUnidad/${desdefecha}/${hastaFecha}/${isAumento}/${valorNuevo}`;
    try {
        const respuesta = await axios.post(URL, dataModPhe,
            {
                headers: authHeaderWithToken(infoUsuario.token),
                responseType: "blob"
            }
        )
        let url = window.URL.createObjectURL(respuesta.data);
        respuestaResponse = { status: respuesta.status, dataResponse: url }
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            var mensaje = await new Blob([error.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();

            respuestaResponse = { status: error.response.status, errorMessage: mensaje }
        }
    }

    return respuestaResponse


}

export async function GuardarModificacionPresupUnidadHE(datosRequest: FormData, desdefecha: string, hastafecha: string, isAumento: boolean, valorNuevo: number) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }


    const url = `${configData.SERVER_URL}ModificacionPresupuestoHE/GuardarModificacionPresupuestoUnidad/${desdefecha}/${hastafecha}/${isAumento}/${valorNuevo}`;
    try {
        const respuesta = await axios.post(url, datosRequest, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function GuardarModificacionbyServidor(modificacion: DetalleServidorPlanHEDTO, fechaDesde: string, fechaHasta: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleServidoresModHEDTOs: DetalleServidoresPlanificacionHE[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleServidoresModHEDTOs }

    const url = `${configData.SERVER_URL}ModificacionPresupuestoHE/GuardarModificacionByServidor/${fechaDesde}/${fechaHasta}`;
    try {
        const respuesta = await axios.post(url, modificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleServidoresModHEDTOs = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleServidoresModHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function GuardarModificacionbyActividad(modificacion: DataActividadSave, fechaDesde: string, fechaHasta: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}ModificacionPresupuestoHE/GuardarModificacionbyActividad/${fechaDesde}/${fechaHasta}`;
    try {
        const respuesta = await axios.post(url, modificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function EditarModificacionbyActividad(modificacion: DataActividadSave, fechaDesde: string, fechaHasta: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}ModificacionPresupuestoHE/EditarModificacionbyActividad/${fechaDesde}/${fechaHasta}`;
    try {
        const respuesta = await axios.post(url, modificacion, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function EliminarModificacionbyActividad(idActividad: number, fechaDesde: string, fechaHasta: string) {
    const infoUsuario: UserData = authenticationService.currentUserValue;

    var detalleActividadPlanHEDTOs: DetalleActividadPlanHEDTO[] = []

    var respuestaResponse: ResponseRequest = { status: -1, dataResponse: detalleActividadPlanHEDTOs }

    const url = `${configData.SERVER_URL}ModificacionPresupuestoHE/EliminarModificacionbyActividad/${idActividad}/${fechaDesde}/${fechaHasta}`;
    try {
        const respuesta = await axios.post(url, {}, {
            headers: authHeaderWithToken(infoUsuario.token),
        });

        detalleActividadPlanHEDTOs = respuesta.data;

        respuestaResponse = {
            status: respuesta.status,
            dataResponse: detalleActividadPlanHEDTOs,
        }

    } catch (error) {
        if (axios.isAxiosError(error) && error.response) {
            respuestaResponse = { status: error.response.status, errorMessage: error.response.data };
        } else {
            respuestaResponse = { status: -1, errorMessage: 'Error desconocido' };
        }
    }
    return respuestaResponse;
}

export async function ObtenerRegimenLaboralPlan() {
    var respuesta: ResponseRequestGeneric<DetalleRegimenLaboralHEDTO[]> = {
        status: -1
    };

    try {
        const URL_COMPLETA = `${configData.SERVER_URL}ModificacionPresupuestoHE/RegimenLaboralPlanificadoActual`
        const responseAxios = await axios.get(URL_COMPLETA, {
            headers: authHeader()
        })
        var data: DetalleRegimenLaboralHEDTO[] = responseAxios.data;

        respuesta = {
            status: responseAxios.status,
            dataResponse: data
        }

    } catch (error) {
        respuesta = hadleAxiosErrorResponse<DetalleRegimenLaboralHEDTO[]>(error)
    }
    return respuesta
}